import React from 'react';
import './tips.scss';

export default class Tips extends React.Component {
  static displayName = 'Tips';
  static propTypes = {
    tipInlineStyle: React.PropTypes.object,
    tooltipText: React.PropTypes.any,
  };

  getTriggerWidth() {
    return this.refs.trigger.offsetWidth;
  }

  render() {
    const { tipInlineStyle, tooltipText } = this.props;
    return (
      <div className="o-tooltip__outer" style={tipInlineStyle.tipOuterStyle}>
        <div
          ref="tooltip"
          className="o-tooltip"
          style={tipInlineStyle.tipStyle}
        >
          {tooltipText}
          <div className="o-tooltip__trigger" style={tipInlineStyle.tipTriggerStyle} ref="trigger"></div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/mui/tips.jsx